/**
 * @type {BD_CFG}
 */
const CONFIG = {
    restURL: window.CFG?.restURL ?? "",
    themeURL: window.CFG?.themeURL ?? "",
    siteURL: window.CFG?.siteURL ?? "",
    nonce: window.CFG?.nonce ?? "",
    firebase: window.CFG?.firebase ?? {
        active_session_id: false,
        key: "",
        auth_domain: "",
        database_url: "",
        auth_token: "",
        team_code: "",
        latest_team_code: "",
        environment: "",
    },
    page_settings: window.CFG?.page_settings ?? {
        home: {
            general: {
                logo: "",
                subtitle: "",
            },
            steps: [],
        },
        timer: {
            general: {
                logo: "",
                subtitle: "",
            },
            button_label: {
                start: "",
                pause: "",
                resume: "",
                stop: "",
            },
            confirmation_popup: {
                header: "",
                title: "",
                subtitle: "",
                button_end_scene: "",
                button_cancel: "",
            },
        },
    },
    color_scheme: window.CFG?.color_scheme ?? {
        primary_color: "",
        secondary_color: "",
        tertiary_color: "",
        body_text_color: "",
        heading_color: "",
    },
    user_id: window.CFG?.user_id ?? 0,
};

export default CONFIG;
